// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"App_backgroundContainer__2e0xD","appContainer":"App_appContainer__u6yPJ"};